export const DialogTypes = {
  PLAYLIST: 'playlist',
  DISPLAY_HUB: 'displayHub',
  DISPLAY_HUB_STORY: 'displayHubStory',
} as const;

export type DialogTypes = (typeof DialogTypes)[keyof typeof DialogTypes];
